import React, { useEffect, useState } from 'react';
import logo from '../img/logo.png';
import { IoGlobeOutline } from 'react-icons/io5';
import { RiMenu3Line } from 'react-icons/ri';
import { VscChromeClose } from 'react-icons/vsc';
import { Menu, Dropdown } from 'antd';

function Navbar() {
  //global dropdown

  const globalMenu = (
    <Menu>
      <Menu.Item>
        <a
          // target='_blank'
          // key='jp'
          rel='noopener noreferrer'
          href='https://sqreemtech.com/jp'
        >
          JP
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          // target='_blank'
          // key='us'
          rel='noopener noreferrer'
          href='https://sqreemtech.com/'
        >
          EN (Default)
        </a>
      </Menu.Item>
    </Menu>
  );
  //header shadow
  const navScroll = () => {
    const header = document.querySelector('header');
    header.classList.toggle('sticky', window.scrollY > 0);
  };
  useEffect(() => {
    window.addEventListener('scroll', navScroll);
    return () => {
      window.removeEventListener('scroll', navScroll);
    };
  }, []);

  //scroll to top
  const handleScrollTop = () => {
    window[`scrollTo`]({ top: 0, behavior: `smooth` });
  };

  //scroll target
  const [target, setTarget] = useState('');

  useEffect(() => {
    if (target) {
      const location = document.querySelector(target);
      console.log(location);
      if (location)
        window.scrollTo({
          top: location.offsetTop - 30,
        });
    }
  }, [target]);

  const handleScrollTarget = (e) => {
    setIsBurgerClicked(false);
    // e.preventDefault();
    if (target === e.target.getAttribute('href')) {
      const location = document.querySelector(target);
      if (location)
        window.scrollTo({
          top: location.offsetTop - 35,
        });
    }
    setTarget(e.target.getAttribute('href'));
  };

  //burger
  const [isBurgerClicked, setIsBurgerClicked] = useState(false);
  const handleClick = () => setIsBurgerClicked(!isBurgerClicked);

  return (
    <>
      <header className='navbar d-flex-row justify-content-between align-items-center'>
        <div className='nav_content d-flex-row justify-content-between align-items-center'>
          <img
            src={logo}
            alt='SQREEM Technologies Logo'
            onClick={handleScrollTop}
          />
          <div className='navbar_right d-flex-row gap-2 align-items-center'>
            <button href='#contact' onClick={handleScrollTarget}>
              Contact Us
            </button>
            <div className='navbar_right_language d-flex-row align-items-center'>
              <p>EN</p>
              <Dropdown
                className='dropdown_global'
                overlay={globalMenu}
                placement='bottomRight'
                arrow
              >
                <IoGlobeOutline />
              </Dropdown>
            </div>
            <div className='close'>
              {isBurgerClicked ? (
                <VscChromeClose onClick={() => handleClick()} />
              ) : (
                <RiMenu3Line onClick={() => handleClick()} />
              )}
            </div>
          </div>
        </div>
        {/* MOBILE LINKS */}
        <ul className={isBurgerClicked ? 'nav_menu active' : 'nav_menu'}>
          <li
            className='nav_menu_item'
            href='#about'
            onClick={handleScrollTarget}
          >
            ABOUT US
          </li>
          <li
            className='nav_menu_item'
            href='#onemarket'
            onClick={handleScrollTarget}
          >
            ONE MARKET
          </li>
          <li
            className='nav_menu_item'
            href='#services'
            onClick={handleScrollTarget}
          >
            SERVICES
          </li>
          <li
            className='nav_menu_item'
            href='#technology'
            onClick={handleScrollTarget}
          >
            TECHNOLOGY
          </li>
          <li
            className='nav_menu_item'
            href='#news'
            onClick={handleScrollTarget}
          >
            NEWS
          </li>
          <li
            className='nav_menu_item'
            href='#contact'
            onClick={handleScrollTarget}
          >
            CONTACT US
          </li>
          <li
            className='nav_menu_item'
            href='#careers'
            onClick={handleScrollTarget}
          >
            CAREERS
          </li>
        </ul>
      </header>
    </>
  );
}

export default Navbar;
